<script setup lang="ts">
import PoolSidebar from "@/features/pool/PoolSidebar.vue";
import { useRouter } from "vue-router";
import { useBleDeviceId } from "@/features/ble/utils/useBleDeviceId.ts";
import { disconnectDevice } from "@/features/ble/utils/disconnectDevice.ts";
import { ref } from "vue";

const router = useRouter();
const bleDeviceId = useBleDeviceId();
const showSidebar = ref(false);

const disconnect = async () => {
  await disconnectDevice(bleDeviceId.value);
  router.push("/");
};
</script>

<template>
  <div class="w-full flex">
    <div
      class="w-11/12 h-full fixed absolute top-0 duration-300 z-20 lg:static lg:w-[350px] flex-shrink-0"
      :style="{ left: showSidebar ? '0' : '-110vw' }"
      v-if="!bleDeviceId"
    >
      <div
        class="absolute inset-0 lg:hidden"
        v-if="showSidebar"
        @click.stop.prevent="showSidebar = false"
      ></div>
      <div
        class="h-full fixed h-100 bg-background lg:w-[350px] max-w-full safe-area-inset-padding-top safe-area-inset-padding-bottom"
      >
        <pool-sidebar @close="showSidebar = false"></pool-sidebar>
      </div>
    </div>

    <div class="m-5 flex-grow safe-area-inset-padding-top relative">
      <router-view
        @openSidebar="!bleDeviceId ? (showSidebar = true) : disconnect()"
      />
    </div>

    <div
      class="absolute inset-0 lg:hidden"
      v-if="showSidebar"
      @click.stop.prevent="showSidebar = false"
    ></div>
  </div>
</template>
